import script from "./LbrxOnHoldTicketsDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./LbrxOnHoldTicketsDrawer.vue?vue&type=script&setup=true&lang=ts"

import "./LbrxOnHoldTicketsDrawer.vue?vue&type=style&index=0&id=5a8c7a20&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a8c7a20"]])

export default __exports__